import { BodyLong, Heading, Link, Table, VerticalSpace } from '@elhub/ds-components'

import React from 'react'
import ReactJson from 'react-json-view'

const json = {
  data: [
    {
      attributes: {
        description:
          'Unit in which solar energy is converted to electricity with equipment/devices not specified.',
        name: 'Solar unspecified'
      },
      id: 'solar',
      type: 'production-groups'
    },
    {
      attributes: {
        description:
          'Unit in which moving water energy is converted to electricity with equipment/devices not specified.',
        name: 'Hydro unspecified'
      },
      id: 'hydro',
      type: 'production-groups'
    },
    {
      attributes: {
        description:
          'Unit in which wind energy is converted to electricity with equipment/devices not specified.',
        name: 'Wind unspecified'
      },
      id: 'wind',
      type: 'production-groups'
    },
    {
      attributes: {
        description:
          'Unit in which heat energy is converted to electricity with equipment/devices not specified.',
        name: 'Thermal unspecified'
      },
      id: 'thermal',
      type: 'production-groups'
    },
    {
      attributes: {
        description:
          'Unit in which the heat source is a nuclear reactor with equipment/devices not specified.',
        name: 'Nuclear unspecified'
      },
      id: 'nuclear',
      type: 'production-groups'
    },
    {
      attributes: {
        description: 'Other unspecified technology.',
        name: 'Other unspecified'
      },
      id: 'other',
      type: 'production-groups'
    }
  ],
  links: {
    self: 'https://api.elhub.no/energy-data/v0/production-groups'
  },
  meta: {
    created: '2023-12-04T12:10:37+01:00',
    lastUpdated: '2023-12-04T12:10:37+01:00'
  }
}

const attributes = [
  { Attribute: 'id', Type: 'String', Description: 'Unique identifier of the consumption group' },
  { Attribute: 'name', Type: 'String', Description: 'Production group name' },
  { Attribute: 'description', Type: 'String', Description: 'Production group description' }
]

const ProductionGroups = () => {
  return (
    <>
      <Heading>Production groups</Heading>
      <BodyLong size='small'>
        Endpoint to get the list of all production groups available to query on the entities (price-areas /
        grid-areas).
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        <b>Use the following endpoint:</b>{' '}
        <Link variant='primary' href='https://api.elhub.no/energy-data/v0/production-groups'>
          https://api.elhub.no/energy-data/v0/production-groups
        </Link>
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>Sample response:</BodyLong>
      <ReactJson src={json} collapsed name={false} sortKeys />
      <VerticalSpace />
      <Table size='small'>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader scope='col'>Attribute</Table.ColumnHeader>
            <Table.ColumnHeader scope='col'>Type</Table.ColumnHeader>
            <Table.ColumnHeader scope='col'>Description</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {attributes.map(({ Attribute, Type, Description }) => (
            <Table.Row key={Attribute}>
              <Table.HeaderCell scope='row'>{Attribute}</Table.HeaderCell>
              <Table.DataCell>{Type}</Table.DataCell>
              <Table.DataCell>{Description}</Table.DataCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

export default ProductionGroups
